import {
  Card as UnstyledCard,
  CardActions as UnstyledCardActions,
  CardContent as UnstyledCardContent,
  CardHeader as UnstyledCardHeader,
  styled,
} from "@mui/material";

export const Card = styled(UnstyledCard)(({ theme }) => ({
  width: theme.spacing(40),
}));

export const CardHeader = styled(UnstyledCardHeader)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  padding: theme.spacing(0.5, 2),
}));

export const CardContent = styled(UnstyledCardContent)(({ theme }) => ({
  overflowWrap: "break-word",
  padding: theme.spacing(2),
}));

export const CardActions = styled(UnstyledCardActions)(({ theme }) => ({
  justifyContent: "space-between",
  marginTop: theme.spacing(-0.75),
  padding: theme.spacing(0, 2, 2),
}));
